// post window.__coverage__ to server every 2 seconds

require('whatwg-fetch');
//var Pike = require('@dp/pike-core-message/dist/index.js')
var Pike = require('@dp/pike-message-web/dist/index.js')
var pikeInstance;
var businessId = "LpSEuoJpjqklhSLW";  //线上线下不一样啊啊啊啊啊啊啊
var rate;
var interval = null;
var os = null;
var device = null;
var appid = null;
var flag = 0;
var oldCoverage = null;
// 实际上访问的 webstatic 资源 host
var __realHost__ = window.location.host;

var _ = require('lodash');


function start(params) {
    if(interval!=null){//判断计时器是否为空
        clearInterval(interval);
        interval=null;
    }
    interval = setInterval(function () {
        if(!_.isEqual(window.__coverage__, oldCoverage)) {
            oldCoverage = _.cloneDeep(window.__coverage__);
            postCoverage(params);
        }
    }, rate*1000);
}

function end() {
    clearInterval(interval);
    interval = null;
}

/**
 * 获取覆盖率数据
 * @param {Function|undefined} coverageProcessor 覆盖率处理器，用于过滤、或者二次处理覆盖率，主要是处理微应用，过滤子应用的覆盖率
 * @param {object} coverage 覆盖率数据
 * @returns
 */
function getCoverage(coverageProcessor, coverage) {
    if (typeof coverageProcessor === 'function') {
        return coverageProcessor(coverage);
    }
    return coverage;
}

function postCoverage(params) {
    // 通过 knb.getDeviceInfo获取设备型号和系统
    var KNB = window.KNB;
    if(typeof KNB !== 'undefined' || KNB !== undefined){
        if (os === null && device === null && flag <= 3) {
            try{
                flag++
                KNB.getDeviceInfo({
                  sceneToken: 'orange',
                  success: function (data) {
                    os = data.os + ' '+ data.osVersion;
                    device = data.model;
                    if (typeof os === 'undefined' || os === null || os.length === 0) { os = null}
                    if (typeof device === 'undefined' || device === null || device.length === 0){ device = null}
                  },
                  fail: function (err) {
                    console.log(err);
                  },
                });
            }catch(err){
                console.error(err);
            }
        }
        if (appid === null && flag <= 3) {
            try{
                KNB.getAppInfo({
                  success: function (data) {
                    appid = data.appid;
                  },
                  fail: function (err) {
                    // empty
                    console.log(err);
                  },
                });
            }catch(err){
                console.error(err);
            }
        }
    }

    var data = {
        "projectKey":params.projectKey,
        "host":__realHost__,
        "commitId":params.commitId,
        "device":device,
        "os":os,
        "appid":appid,
        "coverage": getCoverage(params.coverageProcessor, window.__coverage__)
    }

    fetch('https://orange.sankuai.com/client', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    })
        .then(function() {
            console.log("success!")
        })
        .catch(function() {
            console.log("failed!")
        });
}

function getRealHost(params) {
    var host = window.location.host;
    
    if (params.host) {
      host = params.host;
    }

    if(params.swimlane) {
        var regex = /(?:-sl-(.+))/;
        var match = host.match(regex);
        if(match) {
            // 剔除原有泳道
            host = match[1];
        }
        host = params.swimlane + '-sl-' + host;
    }
    
    return host;
}

function initOrange(params) {
    //把commitId设置为全局变量，让自动化框架获取；
    window.__commitId__ = params.commitId;
    window.__projectKey__ = params.projectKey;
    
    if (!businessId) {
        alert("请初始化businessId，接下来跳转到申请businessId的wiki地址");
        window.location.href = "https://123.sankuai.com/km/page/17949187";
        return
    }
    
    __realHost__ = getRealHost(params);
    
    pikeInstance = new Pike(businessId, {autoConnect: true, env : 'prod'}); // 设置环境，支持 dev、test、stage、prod，若测试环境的话要改这里
    pikeInstance.onReady(function() {
        console.log('start connect');
        var sendData = {
            "projectKey":params.projectKey,
            "host": __realHost__,
            action:"online"
        }

        pikeInstance.send(sendData, function() {
            console.log('send message success!')
        }, function() {
            console.log('send message failed!')
        });
    });


    //解析后端接口数据，是否需要上报覆盖率
    pikeInstance.onMessage(function(result) {
        console.log('收到数据： ' + result)
        if(JSON.parse(result).code == 1){
            console.log("Start to report coverage");
            rate = Number(JSON.parse(result).rate);
            console.log("rate："+rate);
            start(params);
        }
        else {
            console.log("Don't need to report coverage");
            end({})
        }
    })

    //页面关闭时，主动上报覆盖率
    window.onbeforeunload = function() {
        postCoverage(params);
    }

}


module.exports = {
    initOrange: initOrange
};
